import classNames from "classnames";
import {IItem} from "../../types/common.interface";
import "./index.scss";
import {useTranslation} from "react-i18next";

type Props = {
  menus: IItem[];
  onClick: (props: IItem | null) => void;
  selected: IItem | null;
  canNull?: boolean;
};

function CustomRadioButtonGroup({menus, onClick, selected, canNull = true}: Props) {
  const { t } = useTranslation();

  return (
    <nav id="radio-menu-container">
      {menus.map((menu, index) => {
        return (
          <div
            onClick={() => onClick(menu?.value === selected?.value && canNull ? null : menu)}
            key={`menu-${menu.value}-${index}`}
            className={classNames("menu-bg", {
              selectedMenu: selected?.value === menu.value,
            })}>
            <h4>{menu.name && t(menu.name)}</h4>
          </div>
        );
      })}
    </nav>
  );
}

export default CustomRadioButtonGroup;
